import { Modal } from "antd";

/**
 * Valida os dados informados no filtro amarelo
 * @param {Object} data - Informações do formulário
 * @param {Object} pasta - Informações da pasta
 */
const validateAmareloData = (data, pasta) => {
  // Placa
  if (data.possui_placa == "1") {
    if (data.placa == null || data.placa == "" || data.placa.lenght == 0) {
      Modal.error({
        title: "Erro",
        content: "Informe a placa do 3º!"
      });
      return false;
    } else {
      /** Compara a placa informada com a placa do segurado */
      if (pasta.veiculo) {
        if (pasta.veiculo.placa != null) {
          if (pasta.veiculo.placa == data.placa) {
            Modal.error({
              title: "Erro",
              content: "A placa do 3º não pode ser a mesma do segurado!"
            });
            return false;
          }
        }
      }
    }
  }

  // Observacao
  if (data.possui_placa != "1" && data.observacao.length < 1) {
    Modal.error({
      title: "Erro",
      content: "Informe ao menos uma observação!"
    });
    return false;
  }
  return true;
};

export default validateAmareloData;



// WEBPACK FOOTER //
// ./src/pages/Filtro/components/Amarelo/Validator.js